import { render } from "./headerlogo1.vue?vue&type=template&id=0f36e8b2"
const script = {}

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__